import { useState, useEffect, useCallback } from "react";
import { useSelector } from 'react-redux';
import _ from "lodash";

import translateApi from "../../api/translateApi";
import ActionButton from "./ActionButton";
import { getLabel, getLanguage } from "../../tools/Dictionary";
import { dataValidator } from "../../tools/dataValidator";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";

import { getLanguages } from "../../slices/languageSlice";

import "./OptionInput.css";
import { MdOutlineRemoveRedEye, MdMode, MdOutlineExpandLess, MdOutlineExpandMore, MdDeleteForever, MdAdd, MdGTranslate } from "react-icons/md";
import { GiChoice } from "react-icons/gi";

const OptionInput = (props) =>
{

  //Redux
  const Language = useSelector(getLanguages);


  //Props
  const IsDesktop = props.IsDesktop;
  const ReadOnly = props.ReadOnly;
  const Data = props.Data;
  const Property = props.Property;
  const Loading = props.Loading;
  const OnChangeValue = props.OnChangeValue;
  const PreviewStyle = props.PreviewStyle;

  //State
  const [form, setForm] = useState([]);
  const [error, setError] = useState({});
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm, setConfirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });

  const loadData = useCallback((_data) =>
  {
    setForm(_data);
  }, []);


  useEffect(() =>
  {
    loadData(Data);

  }, [Data, loadData]);

  const onChangeValue = (e, _index) => {

    let value = e.target.value;

    if (value && value.length > 20) return;

    let updateForm = _.cloneDeep(form);

    updateForm[_index].value = value;

    if (value && (form[_index].value == form[_index].label[getLanguage().code] || (!form[_index].label[getLanguage().code] && form[_index].label[getLanguage().code] != 0)))//((!updateForm[_index].label[getLanguage().code] || updateForm[_index].label[getLanguage().code] == "") && updateForm[_index].label[getLanguage().code] != "0"))
    {
      updateForm[_index].label[getLanguage().code] = value;
    }


    onValidateField("value", value, _index);

    setForm(updateForm);

  };

  // const onBlurValue = (e, _index) => {


  //   let label = e.target.value;

  //   if (label && label.length > 50) return;

  //   let updateForm = _.cloneDeep(form);

    
  //   if (updateForm[_index].label && ((!updateForm[_index].label.EN || updateForm[_index].label.EN == "") && updateForm[_index].label.EN != "0"))
  //   {


  //     updateForm[_index].label.EN = label;

  //   }
    
  //   // if (updateForm[_index].label && ((!updateForm[_index].label[getLanguage().code] || updateForm[_index].label[getLanguage().code] == "") && updateForm[_index].label[getLanguage().code] != "0"))
  //   // {


  //   //   updateForm[_index].label[getLanguage().code] = label;

  //   // }


  //   setForm(updateForm);


  // };

  const onChangeLabel = (e, _index, _language) =>
  {

    let label = e.target.value;

    if (label && label.length > 50) return;

    let updateForm = _.cloneDeep(form);

    updateForm[_index].label[_language] = label;


    onValidateField("label", label, _index);

    setForm(updateForm);
  };

  // Validate field
  const onValidateField = (_field = "", _value = "", _index = undefined) =>
  {

    let currentError = { ...error };

    let Validation = []; // Array to store validation results
    let currentValidation = [];

    let isValid = true; // Flag to track overall validity



    form.forEach((f, index) => {

      if (_index && _index != index) return;


      if (_field == "" || _field == "value"){

        let currentValue = _field ? _value : f.value;

        currentValidation = dataValidator([
          { field: "value_" + index, value: currentValue, listValidation: ["max:20"] }
        ]);


        Validation = [...Validation, ...currentValidation];
      }

      if (_field == "" || _field == "label")
      {

        Language.forEach(l => {

          if (!f.label[l.code]) return;

          currentValidation = dataValidator([
            { field: "label_" + index + "_" + l.code, value: f.label[l.code], listValidation: ["max:50"] }
          ]);

          Validation = [...Validation, ...currentValidation];
        });

      }


    });

    Validation.forEach(validation =>
    {
      // Iterate over each validation result
      if (validation.valid)
      {
        currentError[validation.field] = ""; // If valid, clear the corresponding error field
      } else
      {
        currentError[validation.field] = validation.reason; // If invalid, set the error reason in the corresponding field
        isValid = false; // Set isValid to false if any validation fails
      }
    });

    setError(currentError); // Update the error state

    return isValid; // Return the overall validity flag

  };

  const onClickMove = (_index, _position) => {

    try
    {

      if (_index + _position < 0 || !form[_index + _position]) return;

      let toMoveForm = _.cloneDeep(form);

      toMoveForm.splice(_index + _position, 0, toMoveForm.splice(_index, 1)[0]);

      setForm(toMoveForm);

    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }


  }

  const onClickDelete = (_index) => {

    setConfirm(confirm => ({
      Title: getLabel("App", "Delete"),
      Message: getLabel("OptionInput", "Delete this option?"),
      Cancel: getLabel("App", "No"),
      onCancel: () => setConfirm(confirm => ({ ...confirm, Display: false })),
      Confirm: getLabel("App", "Yes"),
      onConfirm: () => onDelete(_index),
      Display: true
    }));
  };

  const onDelete = (_index) =>
  {

    try
    {

      setConfirm(confirm => ({ ...confirm, Display: false }));
      setForm(form => form.filter((_, i) => i !== _index));

    } catch (err)
    {
      setConfirm(confirm => ({ ...confirm, Display: false }));

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }


  }

  const onClickAdd = () => {

    try
    {

      let newOption = {
        value: "",
        label: {}
      };

      Language.forEach(l => {
        newOption.label[l.code] = "";
      });

      setForm(form => [...form, newOption])



    } catch (err)
    {


      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }
  };
 
  const onClickSave = () =>
  {

    if (!onValidateField()){
      setAlert({
        Title: getLabel("App", "Error"),
        Message: getLabel("App", "The form contains errors. Please check and fix the fields highlighted in red."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

      return;
    };



    OnChangeValue(form, Property);
    setModal(false);

  };

  const onCloseModal = () =>
  {

    setModal(false);
    loadData(Data);

  };


  const onClickTranslate = async (_textes, _index) =>
  {

    try
    {

     
      
      let sourceLanguage = "";

      for (const key in _textes)
      {
        if (sourceLanguage == "" && _textes.hasOwnProperty(key))
        {
          if (_textes[key] != "") sourceLanguage = key;
        }
      }

      if (sourceLanguage == "") return;



      setLoading(true);

      let targetLanguage = Language.filter(l => l.code != sourceLanguage).map(l => l.code);

      const params = {
        sourceLanguage,
        targetLanguage: targetLanguage,
        text: _textes[sourceLanguage]
      };

      const translateResponse = await translateApi.translateText(params);


      if (!translateResponse.Success)
      {
        let error = new Error()
        error.message = translateResponse.Error && translateResponse.Error.component ? getLabel(translateResponse.Error.component, translateResponse.Error.label) : undefined;

        throw error;
      }


      let updateForm = _.cloneDeep(form);

      translateResponse.Data.forEach(t =>
      {

        updateForm[_index].label[t.language] = t.text;

      });


      setForm(updateForm);
      setLoading(false);

    } catch (err)
    {


      setLoading(false);


      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    };

  }

  //Add a Yes and No options
  const onClickYesNo = () => {

    let toAddOption = [
      {
        value: "Yes",
        label: {}
      },
      {
        value: "No",
        label: {}
      }
    ];

    let Yes = {
      "EN": "Yes",
      "FR": "Oui",
      "ES": "Sì"
    };

    let No = {
      "EN": "No",
      "FR": "Non",
      "ES": "No"
    };

    Language.forEach(l =>
    {
      toAddOption[0].label[l.code] = Yes[l.code] || "";
      toAddOption[1].label[l.code] = No[l.code] || "";
    });

    setForm(form => [...form, ...toAddOption])   

  };


  //onBlur={(e) => onBlurValue(e, index)}
  const displayModal = () =>
  {



    if (!modal) return null;

    return (
      <div className="page_modal_background">
        <div className="page_modal_cont" style={{ width: "700px" }}>
          <div className="page_modal_header_cont" >
            {getLabel("LabelInput", (ReadOnly ? "Display" : "Edit"))}
          </div>
          {(!ReadOnly) &&
            <div className="page_modal_header_action_cont" style={{ minHeight: "40px" }}>
              <ActionButton
                IsDesktop={IsDesktop}
                Label={getLabel("OptionInput", "Yes / No")}
                Title={getLabel("OptionInput", "Set Yes / No Options")}
                Icon={GiChoice}
                Disabled={loading}
                OnClick={onClickYesNo}
                buttonStyle={{ fontSize: "80%", marginRight: "10px" }}
              />
            </div>
          }
          <div className="page_modal_body_cont" style={{ padding: "10px" }}>
            {form.map((f, index) => (
              <div className="optioninput_modal_body_item" key={index} style={{ paddingTop: "20px" }}>
                {!ReadOnly &&
                  <div className="optioninput_action_cont" >
                    <div className="optioninput_action_item page_noselect" title={getLabel("OptionInput", "Move Up Option")} style={{ backgroundColor: "#424849" }} onClick={() => onClickMove(index, -1)}>
                      <MdOutlineExpandLess />
                    </div>
                    <div className="optioninput_action_item page_noselect" title={getLabel("OptionInput", "Move Down Option")} style={{ backgroundColor: "#424849" }} onClick={() => onClickMove(index, 1)}>
                      <MdOutlineExpandMore />
                    </div>
                    <div className="optioninput_action_item page_noselect" title={getLabel("OptionInput", "Delete Option")} style={{ backgroundColor: "#b30000", marginLeft: "5px" }} onClick={() => onClickDelete(index)}>
                      <MdDeleteForever />
                    </div>
                  </div>
                }
                <div className="optioninput_modal_body_item_col">
                  <div className="optioninput_modal_body_item_title">
                    {getLabel("OptionInput", "Value")}
                  </div>
                  <div className="optioninput_modal_body_item_row">
                    <input
                      className={"page_text_input " + (error["value_" + index] ? "page_modal_body_col_input_error" : "")}
                      value={f.value || ""}
                      onChange={(e) => onChangeValue(e, index)}
                      type="text"
                      style={{ width: "80%", textAlign: "center" }}
                      disabled={ReadOnly || Loading}
                    />
                    {error["value_" + index] &&
                      <div className="page_modal_body_col_extra page_modal_body_col_error">
                        {error["value_" + index]}
                      </div>
                    }
                    <ActionButton
                      IsDesktop={false}
                      Label={getLabel("LabelInput", "Instant Translation")}
                      Icon={MdGTranslate}
                      Disabled={loading}
                      OnClick={(loading) ? undefined : () => onClickTranslate(f.label, index)}
                      buttonStyle={{ width: "36px", height: "36px", marginTop: "10px" }}
                    />
                  </div>
                </div>
                <div className="optioninput_modal_body_item_col">
                  <div className="optioninput_modal_body_item_title">
                    {getLabel("OptionInput", "Label")}
                  </div>
                  {Language.map(l => (
                    <div className="optioninput_modal_body_item_row_input" key={l.code}>
                      <div className="optioninput_modal_body_item_row" style={{ width: "10%", textAlign: "right", alignItems: "flex-end", fontWeight: "bold" }} title={l.name}>
                        {l.code}
                      </div>
                      <div className="optioninput_modal_body_item_row" style={{ width: "90%", textAlign: "left", alignItems: "center", marginLeft: "10px" }}>
                        <input
                          className={"page_text_input " + (error["label_" + index + "_" + l.code] ? "page_modal_body_col_input_error" : "")}
                          value={f.label[l.code] || ""}
                          onChange={(e) => onChangeLabel(e, index, l.code)}
                          type="text"
                          style={{ width: "100%", textAlign: "center" }}
                          disabled={ReadOnly || Loading}
                        />
                        {error["label_" + index + "_" + l.code] &&
                          <div className="page_modal_body_col_extra page_modal_body_col_error">
                            {error["label_" + index + "_" + l.code]}
                          </div>
                        }
                      </div>
                    </div>
                  ))}

                </div>
              </div>
            ))}
            {!ReadOnly &&
            <div className="optioninput_modal_body_item" style={{ justifyContent: "center", alignItems: "center", paddingTop: "20px" }}>
              <div className="optioninput_icon_add" title={getLabel("OptionInput", "Add an option")} onClick={onClickAdd}>
                <MdAdd />
              </div>
            </div>
            }
          </div>
          <div className="page_modal_footer_cont">
            <input
              type="button"
              className="page_button page_modal_footer_button"
              value={getLabel("App", "Close")}
              style={{ backgroundColor: "grey", maxWidth: "200px" }}
              onClick={onCloseModal}
              disabled={Loading}
            />
            {!ReadOnly &&
              <input
                type="button"
                className="page_button page_modal_footer_button"
                value={getLabel("App", "Confirm")}
                style={{ maxWidth: "200px" }}
                onClick={onClickSave}
                disabled={Loading}
              />
            }
          </div>
        </div>
      </div>
    );

  };


  if (!Data || !form) return null;

  return (
    <div className="optioninput_cont">
      {displayModal()}
      <AlertModal
        Title={alert.Title}
        Message={alert.Message}
        Confirm={alert.Confirm}
        onConfirm={alert.onConfirm}
        Display={alert.Display}
      />
      <ConfirmModal
        Display={confirm.Display}
        Title={confirm.Title}
        Message={confirm.Message}
        Cancel={confirm.Cancel}
        onCancel={confirm.onCancel}
        Confirm={confirm.Confirm}
        onConfirm={confirm.onConfirm}
      />
      <div className="optioninput_preview_cont">
        <div className="optioninput_preview_item_cont" style={PreviewStyle}>
          {form.map((f, index) => (
            <div className="optioninput_preview_item" key={index}>
              {f.label[getLanguage().code] || f.label["EN"] || "-"}
            </div>
          ))}
        </div>
        <div className="page_button"
          style={{ width: "180px", height: "30px", fontSize: "20px", marginRight: "5px" }}
          title={getLabel("LabelInput", (ReadOnly ? "Display" : "Edit"))}
          onClick={() => setModal(true)}
        >
          <div className="optioninput_preview_col" style={{ width: "30%" }}>
            {ReadOnly ? <MdOutlineRemoveRedEye /> : <MdMode />}
          </div>
          <div className="optioninput_preview_col" style={{ width: "70%" }}>
            {getLabel("LabelInput", (ReadOnly ? "Display" : "Edit"))}
          </div>
        </div>
      </div>
    </div>
  );

}

export default OptionInput;